<template>
  <el-card :style="{ margin: '0 0 10px 0' }">
    <div slot="header" class="clearfix">
      <el-row type="flex" class="row-bg align-center" justify="start">
        <el-checkbox v-model="amoWidget._selected" />
        <el-image
          :src="'https://logo.amocrm.ru' + amoWidget.logo"
          v-if="amoWidget.logo"
          style="width: 50px; height: 34px; margin-right: 10px"
          fit="cover"
        />
        <span>{{ amoWidget.cardTitle }}</span>
      </el-row>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="Info" name="info" lazy>
        <el-form>
          <template v-for="(v, k) in amoWidget.schema">
            <template
              v-if="v.pane === 'info' && (v.visible === undefined || v.visible)"
            >
              <el-form-item :key="k" :label="k" label-width="120px">
                <template v-if="v.type === Boolean">
                  <el-checkbox :disabled="true" v-model="amoWidget[k]" />
                </template>
                <template v-else>
                  <span v-text="v.value || amoWidget[k]"></span>
                </template>
              </el-form-item>
            </template>
          </template>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        label="Settings"
        name="settings"
        :disabled="!amoWidget.settings"
        lazy
      >
        <json-tree :data="amoWidget.settings" />
      </el-tab-pane>
      <el-tab-pane label="AmoCRM" name="amo" :disabled="!amoWidget.amo" lazy>
        <el-form v-if="!!amoWidget.amo">
          <template v-for="(v, k) in amoWidget.amo.schema">
            <el-form-item :key="k" :label="k">
              <template v-if="v.type === Boolean">
                <el-checkbox :disabled="true" v-model="amoWidget.amo[k]" />
              </template>
              <template v-else>
                <span v-text="amoWidget.amo[k]"></span>
              </template>
            </el-form-item>
          </template>
          <el-button @click="handleRedirectToCustomer">Open customer</el-button>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Extended Settings" name="extended_settings" lazy>
        <json-tree :data="amoWidget" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import jsonTree from "vue-json-tree";

export default {
  name: "card",
  components: { jsonTree },
  props: {
    amoWidget: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      activeName: "info"
    };
  },
  methods: {
    handleRedirectToCustomer() {
      this.$router.push({
        name: "customers.details",
        params: {
          id: this.amoWidget._embedded.sharedAmocrm.sharedCustomers_uuid
        }
      });
    }
  }
};
</script>

<style scoped lang="stylus">
label.el-checkbox
    padding-right 10px
</style>
